const globalEvents = {
  LOG_IN: "LOG_IN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  LOG_OUT: "LOG_OUT"
}

export default globalEvents
